import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule AlertFuncCheckCircleSvgModule
 */
@Component({
  selector: 'svg[systemcodeAlertFuncCheckCircle]',
  template: '<svg:g class="nc-icon-wrapper" transform="matrix(.8 0 0 .8 2.4 2.4)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M6 12l4 4 8-8"></svg:path><svg:circle fill="none" stroke-miterlimit="10" cx="12" cy="12" r="11"></svg:circle></svg:g>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertFuncCheckCircleSvgComponent {
}

@NgModule({
  declarations: [
    AlertFuncCheckCircleSvgComponent,
  ],
  exports: [
    AlertFuncCheckCircleSvgComponent,
  ],
})
export class AlertFuncCheckCircleSvgModule {}
